/**
 * `refetchOnReconnect` по умолчанию: сам react-query по возвращении сети не перечитывает, это
 * делает `catchUp`. Своя функция, а не `false`, чтобы отличить значение по умолчанию от явного
 * запрета: запрос, которому перечитываться самому нельзя (анкета после сессии - её чтение
 * записывает показ), ставит `false`, и `catchUp` его тоже не трогает.
 *
 * Отдельным модулем, чтобы клиент запросов не тянул за собой `catchUp` и карту инвалидации сокета.
 */
export const reconnectRefetchByCatchUp = (): boolean => false;
